import React, { Fragment, useEffect } from "react";

import NewNavbar from "../../new-components/NewNavbar";
import NewOverrides from "../../new-components/NewOverrides";
import NewDesignSystem from "../../new-components/NewDesignSystem";
import NewPageHeader from "../../new-components/NewPageHeader";
import NewPageHero from "../../new-components/NewPageHero";
import AboutUsContent from "../../new-components/AboutUsContent";
import NewFooter from "../../new-components/NewFooter";
import NewMadeWith from "../../new-components/NewMadeWith";
import NewScrollTop from "../../new-components/NewScrollTop";
import NewBackButton from "../../new-components/NewBackButton";

const DesprePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Fragment>
      <NewNavbar />
      <NewOverrides />
      <NewDesignSystem />

      <NewPageHeader />
      <NewPageHero
        preTitle="DESPRE NOI"
        title="The Oils Babe"
        subtitle="o poveste despre reconectare"
      />

      <AboutUsContent />

      <NewBackButton />
      <NewFooter />
      <NewMadeWith />
      <NewScrollTop />
    </Fragment>
  );
};

export default DesprePage;
